import TypeSequencer from '#/components/FormatCell/Types/sequencer'

type Props = {
  value: { text: string }[]
}

const TypeCompiledDiagnostics = ({ value }: Props) => {
  return <TypeSequencer value={value} attrName="text" reverse />
}

export { TypeCompiledDiagnostics }
